/**
 * This same funtionality used to be implemented as a import check.
 * However, on real usage this pattern caused problems with SSR and
 * introduced complex dependency issues.
 * Hence why this has been refactored to be a function that can be called
 * when needed.
 * There is added risk that this triggers an error within production,
 * however, given the nature of the linked incident the authors believe
 * this is a worthwhile trade-off. Engineers should encounter this issue
 * during development and testing rather than in production.
 */

/**
 *
 * https://skyscanner.slack.com/archives/C08D4V6QLTC
 * #inc-2025-02-13-saddlebag-bug-caused-consent-to-not-be-forwarded-correctly
 * If this module is ran within a node environment the code will execute, however,
 * will be the wrong logic - server and client have differences within their implementation
 * and if it is trivial for engineers to accidentally import the wrong package into their project then
 * this _will_ occur and cause an incident.
 *
 * @throws {Error} Throws an error if imported in a non-browser environment.
 *
 */
export function checkImportEnvironment() {
  if (typeof window === 'undefined') {
    throw new Error(
      'Please ensure that saddlebag-tracking-preferences has been imported correctly. This module is for client consumption ONLY.',
    );
  }
}
